import { render, staticRenderFns } from "./Zhuan.vue?vue&type=template&id=8ababb82&"
import script from "./Zhuan.vue?vue&type=script&lang=js&"
export * from "./Zhuan.vue?vue&type=script&lang=js&"
import style0 from "./Zhuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports